import { Box, Stack } from '@mui/material';
import React from 'react';
import SignatureCardHeader from '../CardHeader';
import {
  SignatureCardProps,
  SignatureTypeTitle,
} from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/MailSignature';
import { NewLogoURL } from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/MailSignature/@hooks/constants';
import {
  HorizontalDivider,
  LabelAndValue,
  LetterDivider,
} from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/MailSignature/VerticalStyle';
import { useTranslation } from 'react-i18next';

const VerticalPaddingSize = 24;
const VerticalPadding = `${VerticalPaddingSize}px`;
const LogoSize = 90;

const HorizontalStyle = ({
  data: {
    name,
    companyName,
    divisionName,
    positionName,
    departmentName,
    companyAddress,
    phoneNumber,
    email,
    insidePhone,
    logoUrl,
  },
  copyMailSignature,
  wrapperStyle,
}: SignatureCardProps) => {
  const { t } = useTranslation();
  const imgUrlChk = (url?: string) =>
    url?.startsWith('http') ? url : `https://${url}`;

  const id = 'horizontal_style_namecard';

  return (
    <Stack sx={wrapperStyle}>
      <SignatureCardHeader
        title={t(`MYPAGE.${SignatureTypeTitle[id]}`)}
        copyButtonOnClick={() => copyMailSignature(id)}
      />
      <Box
        sx={{
          padding: '12px',
          borderRadius: '8px',
          background: '#F3F5F6',
        }}
      >
        <table
          id={id}
          cellPadding="0"
          cellSpacing="0"
          width="100%"
          style={{
            borderCollapse: 'collapse',
            background: '#fff',
            border: 0,
            tableLayout: 'fixed',
            maxWidth: `720px`,
          }}
        >
          <tbody>
            <tr>
              <td
                style={{
                  padding: '8px 16px 16px',
                }}
              >
                <table
                  cellPadding="0"
                  cellSpacing="0"
                  width="100%"
                  style={{
                    borderCollapse: 'collapse',
                    border: 0,
                    tableLayout: 'fixed',
                  }}
                >
                  {/*  상단 구분선 및 패딩 */}
                  <tbody>
                    <tr>
                      <td
                        style={{
                          height: '1px',
                          backgroundColor: '#000',
                        }}
                      >
                        <div
                          style={{
                            height: '1px',
                            fontSize: '1px',
                            lineHeight: '1px',
                          }}
                        >
                          &nbsp;
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          height: '32px',
                        }}
                      >
                        <div
                          style={{
                            height: '1px',
                            fontSize: '1px',
                            lineHeight: '1px',
                          }}
                        >
                          &nbsp;
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {/*  명함 내용 시작 */}
                        <table
                          cellPadding="0"
                          cellSpacing="0"
                          width="100%"
                          style={{
                            borderCollapse: 'collapse',
                            fontFamily: 'Pretendard, sans-serif',
                            border: 0,
                            tableLayout: 'fixed',
                          }}
                        >
                          <tbody>
                            <tr>
                              {/*  (상단) 회사 로고 */}
                              <td
                                width={`${LogoSize + VerticalPaddingSize}px`}
                                style={{
                                  maxWidth: `${
                                    LogoSize + VerticalPaddingSize
                                  }px`,
                                  verticalAlign: 'top',
                                  paddingRight: VerticalPadding,
                                }}
                              >
                                <img
                                  src={imgUrlChk(logoUrl)}
                                  alt="logo"
                                  style={{
                                    width: '100%',
                                    maxWidth: `${LogoSize}px`,
                                    height: 'auto',
                                  }}
                                />
                              </td>

                              {/*  가운데 구분선 */}
                              <VerticalDivider />

                              {/*  인사 정보 */}
                              <td
                                rowSpan={2}
                                style={{
                                  paddingLeft: VerticalPadding,
                                }}
                              >
                                <table
                                  cellPadding="0"
                                  cellSpacing="0"
                                  width="100%"
                                  style={{
                                    borderCollapse: 'collapse',
                                    fontFamily: 'Pretendard, sans-serif',
                                    background: '#fff',
                                    border: 0,
                                    tableLayout: 'fixed',
                                  }}
                                >
                                  <thead>
                                    {/* (한국어) 이름 및 직급 */}
                                    <tr>
                                      <td>
                                        <span
                                          style={{
                                            color: '#000',
                                            fontSize: '18px',
                                            fontWeight: 500,
                                            lineHeight: '24px',
                                            letterSpacing: '4px',
                                          }}
                                        >
                                          {name.ko}
                                        </span>
                                        <span
                                          style={{
                                            color: '#000',
                                            fontSize: '14px',
                                            fontWeight: 400,
                                            lineHeight: '20px',
                                            marginLeft: '4px',
                                          }}
                                        >
                                          {positionName.ko}
                                        </span>
                                      </td>
                                    </tr>

                                    {/* (영어) 이름 및 직급 */}
                                    <tr>
                                      <td
                                        style={{
                                          paddingBottom: '16px',
                                          verticalAlign: 'middle',
                                          color: '#000',
                                          fontSize: '14px',
                                          fontWeight: 500,
                                          lineHeight: '20px',
                                        }}
                                      >
                                        {name.en}
                                        {name.en && (
                                          <LetterDivider type={'secondary'} />
                                        )}
                                        {positionName.en}
                                      </td>
                                    </tr>

                                    {/* 소속 */}
                                    <tr>
                                      <td
                                        style={{
                                          paddingTop: `28px`,

                                          color: '#000',
                                          fontSize: '14px',
                                          fontWeight: 600,
                                          lineHeight: '20px',
                                        }}
                                      >
                                        <div>{divisionName.ko}</div>
                                        {departmentName}
                                      </td>
                                    </tr>
                                    <tr>
                                      <HorizontalDivider
                                        type={'small-secondary'}
                                        colSpan={1}
                                      />
                                    </tr>
                                  </thead>

                                  {/* 개인정보 */}
                                  <tbody>
                                    <tr>
                                      <td>
                                        <table
                                          cellPadding="0"
                                          cellSpacing="0"
                                          width="100%"
                                          style={{
                                            borderCollapse: 'collapse',
                                            border: 0,
                                            fontFamily:
                                              'Pretendard, sans-serif',
                                            tableLayout: 'fixed',
                                          }}
                                        >
                                          <tbody>
                                            {[
                                              {
                                                type: 'tel',
                                                label: 'M',
                                                value: phoneNumber,
                                                bottomPadding: 8,
                                              },
                                              {
                                                type: 'tel',
                                                label: 'T',
                                                value: insidePhone,
                                                bottomPadding: 8,
                                              },
                                              {
                                                type: 'mailto',
                                                label: 'E',
                                                value: email,
                                                bottomPadding: 0,
                                              },
                                              {
                                                type: 'divider',
                                                label: '',
                                                value: 'divider',
                                                bottomPadding: 8,
                                              },
                                              {
                                                type: 'text',
                                                label: 'A',
                                                value: (
                                                  <>
                                                    {companyName.en}
                                                    <br />
                                                    {companyAddress}
                                                  </>
                                                ),
                                                bottomPadding: 0,
                                              },
                                            ]
                                              .filter((item) => item.value)
                                              .map((item) => {
                                                if (item.type === 'divider') {
                                                  return (
                                                    <tr key={item.label}>
                                                      <HorizontalDivider
                                                        type={'small-secondary'}
                                                        colSpan={2}
                                                      />
                                                    </tr>
                                                  );
                                                }

                                                return (
                                                  <LabelAndValue
                                                    key={item.label}
                                                    {...item}
                                                  />
                                                );
                                              })}
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>

                            {/*  (하단) 디자인 로고 */}
                            <tr>
                              <td
                                style={{
                                  maxWidth: `${100 + VerticalPaddingSize}px`,
                                  paddingRight: VerticalPadding,
                                  verticalAlign: 'bottom',
                                }}
                              >
                                <img
                                  src={NewLogoURL}
                                  alt={'Attractive Active in life logo'}
                                  style={{
                                    width: '100%',
                                    maxWidth: '100px',
                                    height: 'auto',
                                  }}
                                />
                              </td>

                              {/*  가운데 구분선 */}
                              <VerticalDivider />
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Stack>
  );
};

export default HorizontalStyle;

const VerticalDivider = () => {
  return (
    <td
      width={1} /* 숫자 1만 넣기! */
      style={{
        width: '1px',
        minWidth: '1px',
        maxWidth: '1px',
        padding: 0,
        margin: 0,
        backgroundColor: '#000',
      }}
    >
      <span
        style={{
          width: '1px',
          height: '1px',
          fontSize: '0px',
        }}
      >
        &nbsp;
      </span>
    </td>
  );
};
